<template>
  <Common :event="realEvent" :add-time="0" @end="end" @realEnd="realEnd">
    <div class="que-wrap">
      <ul class="que-inner">
        <li v-for="(item, index) in topicList" :key="index">
          <!-- 语音红包 -->
          <template v-if="event.type === 104">
            {{ item.display }}
          </template>
          <template v-else>
            {{ item.content }}
          </template>
        </li>
      </ul>
    </div>
  </Common>
</template>
<script>
// 一呼百应
import { computed } from '@vue/composition-api'
import Common from './Common.vue'
export default {
  components: {
    Common
  },
  props: {
    event: Object
  },
  setup(props, { emit }) {
    const params = computed(() => props.event.params)
    const realEvent = computed(() => {
      const res = props.event || {}
      res.params.duration = 5
      return {
        ...props.event
      }
    })
    const topicList = computed(() => params.value.topicList || [])
    function end() {
      // 倒计时结束
      emit('end', props.event)
    }
    function realEnd() {
      // 倒计时结束
      emit('realEnd', props.event)
    }
    return {
      params,
      end,
      realEnd,
      topicList,
      realEvent
    }
  }
}
</script>
<style lang="less" scoped>
li {
    height: 42px;
    margin-bottom: 12px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 0 14px;
    display: flex;
    align-items: center;
    font-size: 14px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>
